/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import SubscriptionTopicModel from 'cio/models/subscription-topic';
import { AVAILABLE_LANGUAGES } from 'cio/utils/languages';

interface BrowserArgs {
  topics: SubscriptionTopicModel[];
  isShowingMobileView: boolean;
}

export default class BrowserPreview extends Component<BrowserArgs> {
  readonly languages = AVAILABLE_LANGUAGES.map((language) => language.name);
}
